export default "__VITE_ASSET__dtS4eM3a__"